export enum NotificationType {
    SCREENER_QUESTION_REMOVED = 'SCREENER_QUESTION_REMOVED',
    IMAGE_REMOVED = 'IMAGE_REMOVED',
    BIO_REMOVED = 'BIO_REMOVED',
    BANNED = 'BANNED',
    CHANGES_REQUESTED = 'CHANGES_REQUESTED',
    PROFILE_APPROVED = 'PROFILE_APPROVED',
    PROFILE_VERIFIED = 'PROFILE_VERIFIED',
    PROFILE_VERIFICATION_DENIED = 'PROFILE_VERIFICATION_DENIED',
    ID_VERIFIED = 'ID_VERIFIED',
    ID_VERIFICATION_DENIED = 'ID_VERIFICATION_DENIED',
    BACKGROUND_CHECK_APPROVED = 'BACKGROUND_CHECK_APPROVED',
    DIGITAL_DATE_CARD_APPROVED = 'DIGITAL_DATE_CARD_APPROVED',
    DATE_CARD_CHANGES_REQUESTED = 'DATE_CARD_CHANGES_REQUESTED',
    DATE_CARD_APPROVED = 'DATE_CARD_APPROVED',
}